import React, { useEffect } from 'react';
import {
  CarInformationSelector,
  CurrentStepContentSelector,
  CurrentStepSelector,
  HasLoadedFromCookieSelector,
  InitialDataSelector,
  TranslationsSelector,
} from '../../Selectors/FitAssistantSelectors';
import { setHasFinishedSelection, setShowFitAssistant } from '../../Slices/FitAssistantSlice.ts';
import { resetFitAssistant } from '../../Thunks/Reset.ts';
import { useAppDispatch, useAppSelector } from '../../Store/store.ts';
import { trackOK, trackUnconfirmed, trackView } from '../../Analytics/Adobe.ts';
import Buttons from '../Buttons/Buttons.tsx';
import PrimaryButton from '../Buttons/PrimaryButton.tsx';
import SecondaryButton from '../Buttons/SecondaryButton.tsx';
import { CloseType } from '../../Types/Tracking.ts';

const Unconfirmed = () => {
  const dispatch = useAppDispatch();
  const currentStep = useAppSelector(CurrentStepSelector);
  const carInformation = useAppSelector(CarInformationSelector);
  const currentStepContent = useAppSelector(CurrentStepContentSelector);
  const initialData = useAppSelector(InitialDataSelector);
  const translations = useAppSelector(TranslationsSelector);
  const hasLoadedFromCookie = useAppSelector(HasLoadedFromCookieSelector);

  useEffect(() => {
    trackView(
      initialData.FitAssistantVariation,
      currentStep,
      initialData.IsYearFirst,
      carInformation,
      hasLoadedFromCookie
    );

    dispatch(setHasFinishedSelection(true));
  }, []);

  const trackUnconfirmedClick = (closeType: CloseType) => {
    trackUnconfirmed(
      initialData.FitAssistantVariation,
      currentStep,
      initialData.IsYearFirst,
      carInformation,
      closeType
    );
  };

  const onClickPrimary = () => {
    dispatch(setShowFitAssistant(false));

    trackOK(initialData.FitAssistantVariation, currentStep, initialData.IsYearFirst, carInformation);
    trackUnconfirmedClick('Close');
  };

  const onClickSecondary = () => {
    trackUnconfirmedClick('Reset');
    dispatch(resetFitAssistant(false));
  };

  return (
    <>
      <div>
        <div
          className="mb-6"
          dangerouslySetInnerHTML={{
            __html: currentStepContent?.Text ?? '',
          }}
        />
        {currentStepContent?.ImageUrl && (
          <div className="cms-image-wrapper d-flex justify-content-center w-100">
            <img src={currentStepContent?.ImageUrl} alt={currentStepContent?.ImageAlt} />
          </div>
        )}
      </div>
      <Buttons visible>
        <PrimaryButton visible text={translations.confirm} onClick={onClickPrimary} />
        <SecondaryButton visible text={translations.reset} onClick={onClickSecondary} />
      </Buttons>
    </>
  );
};

export default Unconfirmed;
